import * as React from 'react';
import { ConfigContext } from '../ConfigProvider';
/**
 * @desc 空状态
 * @link https://bedrock.netease.com/components/empty
 */

var Empty = function Empty(props) {
  var _React$useContext = React.useContext(ConfigContext),
      getPrettyCls = _React$useContext.getPrettyCls;

  var className = props.className,
      prefixCls = props.prefixCls,
      style = props.style,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      imageNode = props.imageNode,
      text = props.text,
      description = props.description,
      operation = props.operation;
  var prettyCls = getPrettyCls('empty', prefixCls);
  return /*#__PURE__*/React.createElement("div", {
    className: prettyCls({
      size: size
    }, undefined, className),
    style: style
  }, imageNode && /*#__PURE__*/React.createElement("div", {
    className: prettyCls('image')
  }, imageNode), text && /*#__PURE__*/React.createElement("div", {
    className: prettyCls('text')
  }, text), description && /*#__PURE__*/React.createElement("div", {
    className: prettyCls('description')
  }, description), operation && /*#__PURE__*/React.createElement("div", {
    className: prettyCls('operation')
  }, operation));
};

export default Empty;